<template>
  <div class="upload-component text-left mb-2">
    <button class="btn btn-block p-0" @click="$emit('onClick')" type="button">
      <div class="dashed px-6 pt-5">
        <h6 class="d-flex align-items-center gap-1">
          <i class="ph ph-plus fs-16"></i>{{ title }}
        </h6>
        <p class="text-muted text-left">{{ subTitle }}</p>
      </div>
    </button>

    <div v-if="form.title" class="solid px-6 pt-5 my-5">
      <h6 class="text-primary d-flex align-items-center">
        {{ title }}
      </h6>
      <p class="text-primary">{{ form.title }}</p>
    </div>
    <template>
      <slot />
    </template>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "upload" //
    },
    title: {
      type: String,
      default: ""
    },
    subTitle: {
      type: String,
      default: ""
    },
    stars: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      visible: false,
      form: {
        title: "",
        url: ""
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.upload-component {
  position: relative;
  .dashed {
    position: relative;
    background-color: var(--bg-1);
    display: flex;
    border-style: dashed !important;
    border: 1px solid var(--dark-20);
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 16px;
    cursor: pointer;
    width: 100%;
    transition: all 0.2s ease-in-out;
  }
  &:hover {
    .dashed {
      background: var(--dark-4);
      border-color: var(--dark-40);
    }
  }

  .solid {
    display: flex;
    flex-direction: column;
    justify-content: center;
    border-radius: 7px;
    border: 5px dashed #aaaaaa40;
    cursor: pointer;
    width: 100%;
  }

  p {
    font-weight: 500;
  }

  h6 {
    i {
      font-size: 24px;
    }
  }

  small {
    font-size: 9px !important;
  }

  input[type="file"] {
    position: absolute;
    opacity: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    position: absolute;
    cursor: pointer;
  }
  .text-muted {
    font-weight: 400;
    color: #928f98 !important;
  }
}
</style>
